import { prepareForEditing, applyEditing } from '../converters'

describe('TextEditor custom tag converters', () => {
  const replaceRegex = /<(vq-link|cq-link)[^>]*?>[\S\s]*?<\/\1>/g
  const charBase = 0xf222

  describe('prepareForEditing', () => {
    it('should replace cq-link and vq-link tags with special characters', () => {
      const html = '<p><cq-link href="example.com">Link 1</cq-link> and <vq-link>Link 2</vq-link></p>'
      const result = prepareForEditing(html, replaceRegex, charBase)

      const expectedChar1 = String.fromCodePoint(charBase)
      const expectedChar2 = String.fromCodePoint(charBase + 1)

      expect(result.html).toBe(`<p>${expectedChar1} and ${expectedChar2}</p>`)
      expect(Object.keys(result.charsMap)).toHaveLength(2)
      expect(result.charsRegexp).toEqual(new RegExp(`[${expectedChar1}${expectedChar2}]`, 'g'))
    })

    it('should handle tags with attributes', () => {
      const html = '<cq-link id="link1" class="external">Link</cq-link>'
      const result = prepareForEditing(html, replaceRegex, charBase)

      const expectedChar = String.fromCodePoint(charBase)

      expect(result.html).toBe(expectedChar)
      expect(result.charsMap[expectedChar].text).toBe(html)
      expect(result.charsRegexp).toEqual(new RegExp(`[${expectedChar}]`, 'g'))
    })

    it('should not replace other HTML tags', () => {
      const html = '<p>Normal <a href="example.com">link</a></p>'
      const result = prepareForEditing(html, replaceRegex, charBase)

      expect(result.html).toBe(html)
      expect(Object.keys(result.charsMap)).toHaveLength(0)
      expect(result.charsRegexp).toEqual(/a^/) // This regex will never match anything
    })
  })

  describe('applyEditing', () => {
    it('should restore original tags from special characters', () => {
      const originalHtml = '<p><cq-link>Link 1</cq-link> and <vq-link>Link 2</vq-link></p>'
      const prepared = prepareForEditing(originalHtml, replaceRegex, charBase)
      const restored = applyEditing(prepared.html, prepared.charsMap, prepared.charsRegexp)

      expect(restored).toBe(originalHtml)
    })

    it('should handle multiple occurrences of the same tag', () => {
      const originalHtml = '<cq-link>Link 1</cq-link> <cq-link>Link 2</cq-link>'
      const prepared = prepareForEditing(originalHtml, replaceRegex, charBase)
      const restored = applyEditing(prepared.html, prepared.charsMap, prepared.charsRegexp)

      expect(restored).toBe(originalHtml)
    })

    it('should not modify text without special characters', () => {
      const html = '<p>Normal text</p>'
      const charsMap = {}
      const charsRegexp = new RegExp(
        `[${String.fromCodePoint(charBase)}${String.fromCodePoint(charBase + 1)}${String.fromCodePoint(charBase + 2)}]`,
        'g'
      )
      const result = applyEditing(html, charsMap, charsRegexp)

      expect(result).toBe(html)
    })

    it('should preserve character if no replacement found', () => {
      const specialChar = String.fromCodePoint(charBase)
      const html = `${specialChar} No replacement for this`
      const charsMap = {}
      const charsRegexp = new RegExp(`[${specialChar}]`, 'g')
      const result = applyEditing(html, charsMap, charsRegexp)

      expect(result).toBe(html)
    })
  })
})
